/* @flow */

import * as React from 'react';
import styled from 'styled-components';

const Button = styled.input`
  flex: 1;
  background: ${({ theme }) => theme.buttonbg || 'white'};
  border: 1px solid ${({ theme }) => theme.inputBorder || '#ccc'};
  border-color: ${({ selected }) => (selected ? '#999' : '')};
  cursor: pointer;
  outline: none;
  margin: ${({ margin }) => margin || '0  3px auto auto'};
  & :hover {
      border-color: ${({ theme }) => theme.activeBorder};
      color: ${({ theme }) => theme.activeBorder};
    }

  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
`;

export type Props = {
  value: string | number,
  onClick: Function,
  percentBtn: string,
};

export default
class PercentButton extends React.Component<Props> {
  _handleClick = () => {
    const val = this.props.value;
    this.props.onClick(val);
  }

  render() {
    const { value, percentBtn } = this.props;
    return (
      <Button id={percentBtn} type="button" value={`${+value * 100}%`} onClick={this._handleClick} />
    );
  }
}
